import { PublicProfileProvider } from '@/context/PublicProfileContext';
import { ProfileView } from '@/components/shared/ProfileView';
import { EXAMPLE_PROFILE } from '@/data/exampleProfile';

export function ExampleProfilePage() {
  return (
    <>
      <title>Example profile | Nestra</title>
      <PublicProfileProvider value={EXAMPLE_PROFILE}>
        <ProfileView />
      </PublicProfileProvider>
    </>
  );
}
